import mixpanel from "mixpanel-browser";
import React, { useState } from "react";
import Block from "../../../component/block";
import { appStyles } from "../../../utils/appStyle";
import { logContentBlockPressEvent } from "../../../utils/events";
import CopiedNotification from "./CopiedNotification";
import { useAppContext } from './../../../util'

function ClipboardButton({
  content,
  icon,
  highlight,
  color,
  index,
  contentBlockId,
}) {
  const [isCopied, setCopied] = useState(false)
  const { pageId, userId } = useAppContext()

  const copyToClipboard = () => {
    const textToCopy = content;

    const tempTextArea = document.createElement("textarea");
    tempTextArea.value = textToCopy;
    document.body.appendChild(tempTextArea);

    tempTextArea.select();
    document.execCommand("copy");
    document.body.removeChild(tempTextArea);

    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3200);

    logContentBlockPressEvent(contentBlockId);
    mixpanel.track("Web Link Clicked", {
      Button_type: "clipboard",
      distinct_id: userId,
      stack_id: pageId,
    });
  };

  const STYLES = appStyles(color, highlight);

  return (
    <>
      <div
        key={index}
        style={{
          marginTop: "8px",
          borderRadius: STYLES.borderRadius,
          border: STYLES.border,
          background: STYLES.background,
        }}
        onClick={copyToClipboard}
      >
        <div
          style={{
            display: "flex",
            padding: "15px",
            justifyContent: "space-between",
            alignItems: "center",
            color: STYLES.Color,
            cursor: "pointer",
          }}
        >
          <Block
            icon={icon}
            content={content}
            rightIcon="fa-sharp fa-solid fa-clipboard"
          />
        </div>
      </div>
      {isCopied && <CopiedNotification />}
    </>
  );
}

export default ClipboardButton;
